import { createAction, props } from '@ngrx/store';
import { Map, Set } from 'immutable';

import { DcCoreElementType } from '../dc-core-types';
import { CurrentUser } from '../domain/current-user';
import { MarketplaceMemberEntity } from '../domain/marketplace-member.entity';
import { ElementPermission } from '../domain/permission-types';
import { DxFilterField, DxSortField } from '../dx-types';

export enum CoreAction {
	SetUser = '[Core] Set User',
	GoToGdHome = '[Core] Go to generics data project home page',
	GoToHdHome = '[Core] Go to handle data project home page',
	GoToProjects = '[Core] Go to projects page',
	RefreshPics = '[Core] Refresh Pics',
	SetProject = '[Core] Select Project',
	FetchKnownPermissionsPerElementSuccess = '[BE][Core] Fetch known permissions per element success',
	FetchKnownPermissionsPerElementFail = '[BE][Core] Fetch known permissions per element fail',
	GetAvailableMarketplaceMembers = '[Core] Get available marketplace members',
	FetchAvailableMarketplaceMembersSuccess = '[BE][Core] Fetch available marketplace members success',
	FetchAvailableMarketplaceMembersFail = '[BE][Core] Fetch available marketplace members fail',
	ResetAvailableMarketplaceMembers = '[Core] Reset available marketplace members',
	OpenCacheInspector = '[Core] Open cache inspector',
}

export const setUser = createAction(
	CoreAction.SetUser,
	props<{ user: CurrentUser }>()
);

export const goToGdHome = createAction(CoreAction.GoToGdHome);

export const goToHdHome = createAction(CoreAction.GoToHdHome);

export const goToProjects = createAction(CoreAction.GoToProjects);

export const refreshPics = createAction(
	CoreAction.RefreshPics,
	props<{ recentUploads: Set<string> }>()
);

export const setProject = createAction(
	CoreAction.SetProject,
	props<{ projectId: number; projectLabel: string }>()
);

export const fetchKnownPermissionsPerElementSuccess = createAction(
	CoreAction.FetchKnownPermissionsPerElementSuccess,
	props<{ permissions: Map<DcCoreElementType, Set<ElementPermission>> }>()
);

export const fetchKnownPermissionsPerElementFail = createAction(
	CoreAction.FetchKnownPermissionsPerElementFail,
	props<{ error: unknown }>()
);

export const getAvailableMarketplaceMembers = createAction(
	CoreAction.GetAvailableMarketplaceMembers,
	props<{
		consumerType: 'group' | 'user';
		page: number;
		searchTerm: string;
		filterFields: Array<DxFilterField>;
		sortFields: Array<DxSortField>;
	}>()
);

export const fetchAvailableMarketplaceMembersSuccess = createAction(
	CoreAction.FetchAvailableMarketplaceMembersSuccess,
	props<{ members: Map<string, MarketplaceMemberEntity>; total: number }>()
);

export const fetchAvailableMarketplaceMembersFail = createAction(
	CoreAction.FetchAvailableMarketplaceMembersFail,
	props<{ error: unknown }>()
);

export const resetAvailableMarketplaceMembers = createAction(
	CoreAction.ResetAvailableMarketplaceMembers
);

export const openCacheInspector = createAction(CoreAction.OpenCacheInspector);
